module.exports = __webpack_public_path__ + "img/IMG_6726_L_Foamcore_MockedUp.ee95face.jpg";